import { byNext, recurringApi } from '@/store/api/recurring/recurring.api';
import { dropRecurringCalendar, writeRecurringCalendar } from '@/store/api/recurring/recurring.calendar.cache';
import type { TypeAppDispatch } from '@/store/store';
import type { TypeRecurring } from '@/types/recurring/types.recurring';
import { upsertById } from '@/store/api/base/api.cache';

export const writeRecurring = (dispatch: TypeAppDispatch, recurring: TypeRecurring) => {
    dispatch(recurringApi.util.updateQueryData('listRecurrings', undefined, (draft) => {
        upsertById(draft, recurring);
        draft.sort(byNext);
    }));
    writeRecurringCalendar(dispatch, recurring);
};

export const dropRecurring = (dispatch: TypeAppDispatch, id: string) => {
    dispatch(recurringApi.util.updateQueryData('listRecurrings', undefined, (draft) => draft.filter((entry) => entry.id !== id)));
    dropRecurringCalendar(dispatch, id);
};
